import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, hasPermission, ROUTER_PATHS, sizeTab } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableSolicitudCanje from "../../shared/TableSolicitudCanje";
import TableSolicitudEvento from "../../shared/TableSolicitudEvento";

export default function SolicitudEventoCanjePage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title="Solicitud Evento/Canje"
      py={2}
      enableRedirect={hasPermission(PermissionsEnum.api_add_solicitudevento)}
      urlRedirect={ROUTER_PATHS.marketing.solicitudesCanjeEventoCrearNav}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Canjes'} {...a11yProps(0)} />
          <Tab label={'Eventos'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudCanje/>
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudEvento/>
      </CustomTabPanel>

    </SingleTableBoxScene >
  );

}

